import { createApp } from 'vue';
import SampleButton from './SampleButton.vue';
import store from 'shared/store';

const sampleButtonContainer = document.querySelector('[data-feature="sample-button"]');

if (sampleButtonContainer) {
    const app = createApp({
        name: 'SampleButtonApp',
    });
    app.use(store);
    app.component('sample-button', SampleButton);
    app.mount(sampleButtonContainer);
}
